import { useEffect, useState } from "react";
import "./Login.css"; // Importar el archivo CSS
import { supabase } from "../../Servicios/supabaseClient";
import titulo from '../../Img/titulo.png'
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { ClipLoader } from 'react-spinners';

export default function Login() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    // Verificar si el usuario ya está autenticado
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        // Si ya está autenticado, redirigimos al dashboard
        window.location.href = "/dashboard";
      }
    };
    checkSession();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      Swal.fire({
        icon: 'error',
        title: 'Campos incompletos',
        text: 'Por favor, completa todos los campos.',
        confirmButtonColor: '#d33'
      });
      return;
    }

    setLoading(true);

    try {
      // Usamos el método de Supabase para "Iniciar Sesión"
      const { data, error } = await supabase.auth.signInWithPassword({
        email: email,
        password: password,
      });

      if (error) throw error;

      // Si el login es exitoso (no hay error),
      // el 'onAuthStateChange' (que veremos en el Paso 3)
      // se disparará y actualizará el estado global.
      // Solo necesitamos redirigir al dashboard.
      navigate('/');

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `Error en el inicio de sesión: ${error.message}`,
        confirmButtonColor: '#d33'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="loginPage">
      {loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <ClipLoader color="#ffffff" size={50} />
        </div>
      )}
      <div className="loginContainer">
        <img src={titulo} style={{ width: "100%" }} alt="" />
        <p className="loginSubtitle" style={{ margin: "0.5rem" }}>¡Valorar tu tiempo nunca fue tan facil!</p>

        <form className="loginForm" onSubmit={handleSubmit}>
          <div className="inputGroup">
            <label htmlFor="email" className="inputLabel">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className="inputField"
              placeholder="Ingresa tu email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="inputGroup">
            <label htmlFor="password" className="inputLabel">Contraseña</label>
            <input
              type="password"
              id="password"
              name="password"
              className="inputField"
              placeholder="Ingresa tu contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <button type="submit" className="loginBtn">Iniciar sesión</button>
        </form>
        <div className="loginFooter">
          <p>¿No tienes cuenta? <a href="/register" className="loginLink">Regístrate aquí</a></p>
        </div>
        <div className="loginFooter">
          <p>¿Olvidaste tu contraseña? <a href="/forgot-password" className="loginLink">Recuperar contraseña</a></p>
        </div>
      </div>
    </div>
  );
}
